module.exports = __webpack_public_path__ + "static/media/me.37b693f6.svg";